import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_soft_durian.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganSoftDurianBun() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Soft Durian Bun",
    content_category: "Vegan Menu",
    content_ids: ["vegan_soft_durian_bun"],
    content_type: "vegan_vietnamese_pastries",
    value: 4.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Soft Durian Bun | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="A tender spiral bun filled with real durian—creamy, intense, and deeply satisfying for those who love this distinctive Southeast Asian flavor character."
        />
        <meta
          property="og:title"
          content="Vegan Soft Durian Bun | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="A tender spiral bun filled with real durian—creamy, intense, and deeply satisfying for those who love this distinctive Southeast Asian flavor character."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN SOFT DURIAN BUN"
          titleSubHead="$4.00 each"
          detailBody="A tender spiral bun filled with real durian—creamy, intense, and deeply satisfying for those who love this distinctive Southeast Asian flavor character."
          detailBodyBr="Contains: wheat"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganSoftDurianBun;